import { render, staticRenderFns } from "./ProjectUserPledges.vue?vue&type=template&id=21de88ab"
import script from "./ProjectUserPledges.vue?vue&type=script&lang=js"
export * from "./ProjectUserPledges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports